export default __webpack_public_path__ + "static/media/discord.07e45e41.svg";